<template>
  <div class="page login">
    <div class="logo">
      <el-image class="logo-img" :src="logoImg" />
      <span class="logo-txt"></span>
    </div>
    <div class="container">
      <div class="contain-right">
        <div class="theme">
          <div class="title">{{ loginText }}</div>
          <div class="ornament"></div>
        </div>
        <el-form class="rule-form" ref="ruleForm" :model="formData" :rules="formRules">
          <el-form-item label prop="username">
            <div class="login-input">
              <el-input v-model.trim="formData.username" class="input-full" placeholder="请输入账号" clearable
                @change="changeUsername">
                <template slot="prepend">
                  <img class="icon" :src="icon01" />
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label prop="password">
            <div class="login-input">
              <el-input v-model.trim="formData.password" class="input-full" placeholder="请输入密码" show-password clearable
                @change="changePassword">
                <template slot="prepend">
                  <img class="icon" :src="icon03" />
                </template>
              </el-input>
            </div>
          </el-form-item>
        </el-form>
        <div class="login-item tips">
          <el-checkbox v-model="isSavePass">记住密码</el-checkbox>
          <div class="register" @click="toForgotPassword">忘记密码?</div>
        </div>
        <div class="login-item btns logbt" v-if="auth_login_sso_direct">
          <el-button class="btn btn-gray" @click="authentication">统一身份认证</el-button>
        </div>

        <div class="login-item btns">
          <el-button v-if="signLoad" class="btn" type="primary" round :disabled="signLoad">
            <span class="el-icon-loading loadingIcon"></span>
            <span class="loadingText">正在登录中</span>
          </el-button>
          <el-button v-else class="btn" type="primary" round @click="handleLogin">本地登录</el-button>
        </div>
        <div class="register" @click="toRegister">注册账号</div>
      </div>
    </div>
  </div>
</template>

<script>
import { delCookie } from "@/utils/cookie"
import { getuserinfo } from "@/api/user"
import { setWebNameToken, setWebAvaterToken } from "@/utils/auth"
const systemConfig = sessionStorage.getItem("systemConfig") || ""
const systemInfo = systemConfig ? JSON.parse(systemConfig) : ""
import { mapState } from "vuex"
const request_base_path = require("@/utils/base_url")
export default {
  name: "Login",
  components: {},
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请输入正确的登录密码"))
      } else {
        callback()
      }
    }
    return {
      logoImg: require("@/assets/logo.png"),
      loginText: "文化项目管理平台",
      auth_login_sso_direct: systemInfo.auth_login_sso_direct,
      icon01: require("@/assets/login/account.png"),
      icon02: require("@/assets/login/account_gray.png"),
      icon03: require("@/assets/login/password.png"),
      icon04: require("@/assets/login/password_gray.png"),
      icon05: require("@/assets/icon/user_mask.png"),
      formData: {
        username: "", // 手机号格式
        password: "",
      },
      formRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      isSavePass: false, // 记住密码
      signLoad: false, // 登录防抖
    }
  },
  computed: {
    ...mapState(["websiteInfo"]),
  },
  watch: {
    websiteInfo: {
      handler(newVal, oldVal) {
        // console.log("网站信息", newVal, oldVal);
        if (newVal) {
          this.logoImg = newVal.portal_head_logo
          // this.loginText = newVal.portal_name;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    delCookie() // 清除cook
  },
  mounted() {
    this.getCookie()
  },
  methods: {
    // 变更-用户
    changeUsername(row) {
      if (row) {
        this.icon2 = this.icon1
      } else {
        this.icon1 = this.icon2
      }
    },
    // 变更-密码
    changePassword(row) {
      if (row) {
        this.icon4 = this.icon3
      } else {
        this.icon3 = this.icon4
      }
    },
    // 忘记|找回 密码
    toForgotPassword() {
      this.$router.push("/forgot-password")
    },
    // 登录
    handleLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // let strTip =
          //   "特别说明：为保障师生员工数据安全，请用户勿使用第三方软件(或APP) 模拟登陆教学管理系统、学生管理系统、智慧实践教学平台等。对第三方软件(或APP) 模拟登陆获取师生员工数据的行为，将对相关服务器IP封禁。"
          // this.$confirm(strTip, {
          //   confirmButtonText: "继续登录",
          //   cancelButtonText: "取消",
          //   showClose: false,
          //   center: true,
          // }).then(() =>   {

          // }).catch(() =>   {
          //   return false
          // })
          this.signLoad = true // 登录防抖
          // 调用vuex内login登录方法
          this.$store
            .dispatch("login", this.formData)
            .then(async (res) => {
              this.signLoad = false // 取消登录防抖
              if (res.code === 0 && res.data) {
                // 记住密码
                if (this.isSavePass) {
                  this.setCookie(
                    this.formData.username,
                    this.formData.password,
                    7
                  ) // 传入账号名，密码，和保存天数3个参数
                } else {
                  this.clearCookie() // 清空Cookie
                }
                let res = await getuserinfo() // 新增接口请求code:16时，登录会短暂跳转到首页再次跳转到/closed页，逻辑处理
                try {
                  if (res.code === 16) {
                    return false
                  } else if (res.code === 0) {
                    this.$store.commit("SET_User_Info", res.data)
                    this.$store.commit("SET_Username", res.data.name)
                    // localStorage.setItem("username", res.data.name)
                    localStorage.setItem("usernumber", res.data.username)
                    setWebNameToken(res.data.name)
                    this.$store.commit("SET_Useravater", res.data.avatar)
                    setWebAvaterToken(res.data.avatar)
                  }
                  localStorage.setItem("live_login_flag", "0")
                  this.$router.replace({ path: "/home" })
                } catch (error) { }
              }
            })
            .catch(() => { })
        } else {
          return false
        }
      })
    },
    // 统一身份验证
    authentication() {
      if (process.env.NODE_ENV == "development") {
        let str = request_base_path.dev_url + "#/sign_on"
        location.href =
          request_base_path.dev_url +
          "sso-login?fromtype=3&redirect_url=" +
          encodeURIComponent(str)
      } else if (process.env.NODE_ENV == "production") {
        let str = request_base_path.pro_url + "#/sign_on"
        location.href =
          request_base_path.pro_url +
          "sso-login?fromtype=3&redirect_url=" +
          encodeURIComponent(str)
      }
    },
    // 注册
    toRegister() {
      this.$router.push("/register")
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date() //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString()
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString()
    },
    //读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ") //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=") //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.formData.username = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.formData.password = arr2[1]
            this.isSavePass = true
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1) //修改2值都为空，天数为负1天就好了
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100vh;
  background: #f5f5f5 url('~@/assets/login/bg.jpg') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    position: absolute;
    left: 3%;
    top: 3%;

    .logo-img {
      height: 8vh;
    }
  }

  .container {
    width: 32%;
    max-width: 620px;
    height: 68vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .contain-right {
      flex: 1;
      max-width: 600px;
      padding: 40px 60px;
      background-color: #fff;
      border-radius: 20px;

      .theme {
        width: 100%;
        min-height: 40px;

        .title {
          color: #000;
          font-size: 24px;
          font-weight: bold;
          line-height: 1.5;
          text-align: center;
          margin-bottom: 20px;
        }

        .theme-logo {
          width: auto;
          height: 60px;
        }

        .ornament {
          width: 100%;
          min-height: 10px;

          .img {
            width: 100%;
          }
        }
      }

      .rule-form {
        width: 100%;

        .login-input {
          padding: 20px 0 10px;
          border-bottom: 1px solid #ddd;

          .icon {
            width: 20px;
            height: 20px;
          }

          ::v-deep .input-full {
            flex: 1;

            .el-input__inner {
              border: none;
            }

            .el-input-group__prepend,
            .el-input-group__append {
              background-color: transparent;
              border-color: transparent;
            }
          }
        }
      }

      .login-item {
        width: 100%;
        margin-bottom: 10px;
      }

      .login-item.tips {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .login-item.btns {

        // margin-top: 50px;
        .btn {
          width: 100%;
          line-height: 30px;
          margin: 0;
          margin-bottom: 10px;
          border-radius: 30px;
        }
      }

      .login-item.logbt {
        margin-top: auto;
      }
    }
  }
}

.register {
  display: flex;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  line-height: 18px;
  flex-wrap: nowrap;
  justify-content: center;
  cursor: pointer;
}

.btn-gray {
  color: #fff;
  background-color: #005cbb;
  border-color: #005cbb;
}

@media screen and (max-width: 640px) {
  .page {
    background-size: cover;

    .logo {
      left: 5%;
      top: 2%;

      .logo-img {
        height: 5vh;
      }
    }

    .container {
      width: 90%;
      max-width: 400px;
      height: auto;
      min-height: 50vh;

      .contain-right {
        padding: 30px 20px;
        border-radius: 12px;

        .theme {
          .title {
            font-size: 20px;
            margin-bottom: 10px;
          }
        }

        .rule-form {
          .login-input {
            padding: 10px 0 5px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .container {
      width: 50%;
      max-width: 500px;

      .contain-right {
        padding: 30px 40px;
      }
    }
  }
}
</style>